import { IStackStyles, ITextStyles, Stack, Text, getTheme } from "@fluentui/react";
import { TransactionMessage } from "../types";

interface MessagesProps {
  message: TransactionMessage | undefined;
}

export const Messages = ({ message }: MessagesProps) => {
  const displayMessages = message?.messages.map((value, index) => (
    <Text
      key={index}
      styles={message.isError ? validationErrorStyle : validationInfoStyle}
    >
      {value}
    </Text>
  ));

  return <Stack styles={containerStyles}>{displayMessages}</Stack>;
};

const theme = getTheme();
const containerStyles: IStackStyles = {
  root: {
    minHeight: 50,
    height: 50,
  },
};

const validationErrorStyle: ITextStyles = {
  root: {
    color: theme.palette.red,
  },
};

const validationInfoStyle: ITextStyles = {
  root: {
    color: theme.palette.neutralPrimary,
  },
};
